import { Modal, Form } from "react-bootstrap";
import ErrorAlert from "../../../../common/ui/ErrorAlert";

export default function MobileModalPage(props) {
    const formData = props.loyaltyMember.MobileModalPage;
    return (
        <>
            <div className="modal-header justify-content-start">
                <h1 className="modal-title fs-5">Loyalty Login</h1>
            </div>
            <Modal.Body>
                <div className="row justify-content-center mx-0 gy-4 mb-2">
                    <div className="col-sm-10 col-12 text-center">
                        Please enter your mobile number associated with your loyalty account
                    </div>
                    <div className="col-sm-10 col-12">
                        <Form.Floating>
                            <Form.Control type="tel" id="txtAuthMobile" name="authmobile" className={formData.Fields.authmobile.HasError ? "is-invalid" : ""} value={formData.Fields.authmobile.Value} onChange={props.handleChangeMobileFields} maxLength={formData.Fields.authmobile.MaxLength} disabled={formData.GeneralError.ButtonsDisabled}></Form.Control>
                            <Form.Control.Feedback type="invalid">{formData.Fields.authmobile.ErrorMessage}</Form.Control.Feedback>
                            <label htmlFor="txtAuthMobile">Mobile</label>
                        </Form.Floating>
                    </div>
                    { formData.GeneralError.HasError && <div className="col-sm-10 col-12"><ErrorAlert message={formData.GeneralError.ErrorMessage} /></div> }
                    <div className="col-sm-10 col-12 justify-content-center">
                        <button type="button" className="btn btn-dark rounded-pill w-100" onClick={props.handleNextValidateMobile} disabled={formData.GeneralError.ButtonsDisabled}>
                            Next
                            { formData.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></> }
                        </button>  
                    </div>
                    <div className="d-flex flex-row align-items-center">
                        <hr className="w-100"/>
                        <small className="px-3 text-muted">OR</small>
                        <hr className="w-100"/>
                    </div>
                    <div className="col-sm-10 col-12 justify-content-center">
                        <button type="button" className="btn btn-outline-dark rounded-pill w-100" onClick={props.handleClickCloseLoyaltyModal} disabled={formData.GeneralError.ButtonsDisabled}>Continue as guest</button>
                    </div>
                </div>
            </Modal.Body>
        </>
    )
}